import { defineRecipe } from '@chakra-ui/react'

export const buttonRecipe = defineRecipe({
  base: {
    color: 'brand.blue',
    borderRadius: '3px',
    fontWeight: 500,
  },
  variants: {
    variant: {
      solid: { color: 'white', backgroundColor: 'facebook.500', _hover: { backgroundColor: 'facebook.600' } },
      bankid: { color: 'white', backgroundColor: '#39134C', _hover: { backgroundColor: '#470D70' } },
      outline: {
        outlineColor: 'brand.blue',
        color: 'brand.blue',
        borderSize: '0px',
        outlineWidth: '1px',
        outlineOffset: '0px',
        outlineStyle: 'solid',
      },
      link: {
        fontWeight: 400,
        color: 'brand.blue',
        textDecoration: 'underline',
      },
    },
  },
})
